import React, { useState } from 'react';
import { Marker, InfoWindow } from '@react-google-maps/api';
import { STORE_STATUS } from 'helpers/constants';

const ViewStoreMarkers = (props) => {
  const { zonesAllInfo } = props;

  const [selectedSokMarker, setSelectedSokMarker] = useState(null);

  return (
    <>
      {zonesAllInfo.map((zone, index) => (
        <Marker
          key={index}
          position={{
            lat: zone?.store.latitude,
            lng: zone?.store.longitude,
          }}
          icon={
            zone.store.status === STORE_STATUS.PASSIVE
              ? '/static/img/ceptesok-offline.svg'
              : '/static/img/ceptesokpin.svg'
          }
          onClick={() => setSelectedSokMarker(zone?.store)}
        />
      ))}
      {selectedSokMarker && (
        <InfoWindow
          style={{ maxWidth: '150px', maxHeight: '100px' }}
          position={{
            lat: selectedSokMarker?.latitude,
            lng: selectedSokMarker?.longitude,
          }}
          onCloseClick={() => setSelectedSokMarker(null)}
        >
          <div>{selectedSokMarker?.name}</div>
        </InfoWindow>
      )}
    </>
  );
};

export default ViewStoreMarkers;
